import { createContext, useContext, useState, useEffect, useMemo, useCallback } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("eon_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem("eon_cart", JSON.stringify(items)); }, [items]);

  const add = (product, size = null) => {
    const chosen = size || (product.variants && product.variants[0]) || null;
    setItems((prev) => {
      const existing = prev.find((i) => i.product_id === product.id && i.size === chosen);
      if (existing) return prev.map((i) => i.product_id === product.id && i.size === chosen ? { ...i, quantity: i.quantity + 1 } : i);
      return [...prev, { product_id: product.id, name: product.name, price: product.price, image: product.image, quantity: 1, size: chosen }];
    });
  };
  const remove = (product_id, size = null) => setItems((prev) => prev.filter((i) => !(i.product_id === product_id && i.size === size)));
  const setQty = (product_id, quantity, size = null) =>
    setItems((prev) => prev.map((i) => i.product_id === product_id && i.size === size ? { ...i, quantity: Math.max(1, quantity) } : i));
  const clear = useCallback(() => setItems([]), []);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  const value = useMemo(
    () => ({ items, add, remove, setQty, clear, count, total }),
    [items, count, total, clear]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}
